import { z } from 'zod';

export enum AddressTypeEnum {
  Home = 1,
  Work = 2,
  Other = 3,
}

export enum AddressTypeStrEnum {
  Home = 'Home',
  Work = 'Work',
  Other = 'Other',
}

export type AddressRequest = {
  id: number;
  name: string;
  type: AddressTypeEnum;
  type_str: string;
  type_str_ar: string;
  type_str_en: string;
  street: null;
  zip_code: null;
  city: null;
  province: null;
  country: null;
  location: Location;
  details: string | undefined;
  user_id: string;
};
export type Location = {
  longitude: number;
  latitude: number;
};

const inputAddress = z.object({
  name: z.string(),
  type: z.number(),
  details: z.string().optional(),
  id: z.string().optional(),
  location: z.object({ longitude: z.number(), latitude: z.number() }),
  street: z.string().optional(),
  zip_code: z.string().optional(),
  city: z.string().optional(),
  province: z.string().optional(),
  country: z.string().optional(),
});

export type InputAddress = z.infer<typeof inputAddress>;
